<template>
  <div class="consult_box">
    <mt-header fixed title="公开咨询" style="background:#ffffff;color:#262626;">
    </mt-header>
    <div class="scroll-container-app">
 <Scroll
      ref="scroll"
      @pullingDown="loadRefresh"
      @pullingUp="loadMore">
      <!-- 滚动的内容 -->
      <ul>
        <li @click.stop="goDetail(item)" v-for="(item, index) in consultList" :key="index">
          <div class="user_box">
            <div class="user_left">
              <img :src="item.avatar_url || user_img"/>
              <div>
                <p class="p_14">{{item.username}}</p>
                <p class="p_12">{{item.last_posted_at}}</p>
              </div>
            </div>
            <div class="user_right" :class="{'is_self': item.like_action==2}">
              <img src="../assets/images/n_appreciate_select@2x.png" v-if="item.like_action==2"/>
              <img src="../assets/images/n_appreciate_normal@2x.png" v-else/>
              <span>{{item.like_count}}</span>
            </div>
          </div>
          <div class="text_con">
            <p class="p_13">{{item.post.content}}</p>
            <div class="img_box">
              <img
                class="previewer-demo-img"
                v-for="(imgItem, imgIndex) in item.post.images.slice(0,3)"
                :src="imgItem.thumb"
                width="100"
                @click.stop="show(imgIndex, item.post.images.slice(0,3))"
                :key="index + '_' + imgIndex"
              />
            </div>
          </div>
          <div class="reply" v-if="item.reply">
            <span>{{item.reply.eng_name}}：</span><span>{{item.reply.content}}</span>
            <div class="img_box">
              <img
                class="previewer-demo-img"
                v-for="(imgItem, imgIndex) in item.reply.images.slice(0,3)"
                :src="imgItem.thumb"
                width="100"
                @click.stop="show(imgIndex, item.reply.images.slice(0,3))"
                :key="index + '_' + imgIndex"
              />
            </div>
          </div>
        </li>
      </ul>
    </Scroll>
    </div>

    <div v-if="!consultList.length" class="noData">
      <img src="../assets/images/bg_consult_null@2x.png"/>
      <p>暂无公开咨询</p>
    </div>
    <previewer ref="previewer" :list="list" :options="options"> </previewer>
    <div class="fixed_btn_box">
      <a class="fixed_btn" :href="downloadUrl" @click.prevent="set_m_by_consult($event)">APP内发起咨询</a>
    </div>
    <Footer_></Footer_>
  </div>
</template>

<script>
  import Scroll from 'vue-slim-better-scroll'
  import Footer_ from './Footer.vue';
  import user_img from '../assets/images/bg_consult_anonymous@2x.png';

  export default {
    metaInfo: {
      title: '公开咨询',
      meta: [{
        name: 'keyWords',
        content: ''
      },{
        name: 'description',
        content: ''
      }]
    },
    data(){
      return{
        list: [],
        options: {
          getThumbBoundsFn(index) {
            let thumbnail = document.querySelectorAll('.previewer-demo-img')[
              index
              ];
            let pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            let rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        },
        consultList: [],
        newList: [],
        page: 1,
        downloadUrl: window.config.gsx_dl_base+'m.gsx.discussion',
        user_img: user_img
      }
    },
    mounted () {
      this.loadRefresh();
    },
    created(){
    },
    methods:{
      async goDetail (item){
        this.$router.push({name:"consultDetail",params:{id:item.id}})
      },
      getConsultList(page=1){
        let access_token = localStorage.access_token
        let info = {
          page,
          access_token: access_token
        }
        this.$store.dispatch('getConsultList',info).then((res)=>{
          let result = res.data
          if(result.code == 0){
            result.data.map((item,index) => {
              item.post.images && item.post.images.map((imgItem, imgIndex) => {
                  imgItem.msrc = imgItem.url;
                  imgItem.src = imgItem.url;
              })
              item.reply && item.reply.images && item.reply.images.map((imgItem, imgIndex) => {
                imgItem.msrc = imgItem.url;
                imgItem.src = imgItem.url;
              })
            })
            this.newList = result.data;
            if(!this.consultList.length&&this.page===1){
              this.consultList = result.data;
            }else{
              this.consultList.push(...result.data);
            }
          }
        })
      },
      show(index,imgList) {
        console.log(imgList)
        // 显示特定index的图片，使用ref
        this.list = imgList;
        setTimeout(() => {
          this.$refs.previewer.show(index);
        },100)
      },
      // 加载刷新数据
      async loadRefresh () {
        this.consultList = [];
        await this.getConsultList(1);
        // 初始化数据
        this.page = 1;
        setTimeout(() => {
          this.$refs.scroll.update(true)
        }, 300)
      },
      // 加载更多数据
      async loadMore () {
        const page = this.page + 1;
        await this.getConsultList(page);
        if(this.newList.length < 2){
          this.$refs.scroll.update(true)
        }else{
          this.page++
        }
      }
    },
    components:{
      Footer_,
      Scroll
    },
  }
</script>

<style scoped lang="scss">
  @import '../assets/css/base.scss';
  .consult_box {
     height:calc(100% - 42px);
    background: #F2F5FA;
    padding-top: pxtorem(42px);
    box-sizing: border-box;
    .scroll-container-app {
      height: 100%;
      box-sizing: border-box;
      padding: pxtorem(14px);
    }
    ul {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      li {
        padding: pxtorem(16px) pxtorem(20px) pxtorem(20px) pxtorem(16px);
        background: #fff;
        border-radius: pxtorem(8px);
        &:not(:last-child) {
          margin-bottom: pxtorem(14px);
        }
        .user_box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: pxtorem(12px);
          .user_left {
            display: flex;
            align-items: center;
            > img {
              width:pxtorem(34px);
              height:pxtorem(34px);
              margin-right: pxtorem(10px);
              border-radius: 50%;
            }
            .p_14 {
              font-size: pxtorem(14px);
              color: #262626;
              line-height: pxtorem(20px);
            }
            .p_12 {
              font-size: pxtorem(12px);
              color: #ccc;
              line-height: pxtorem(17px);
            }
          }
          .user_right {
            font-size: pxtorem(16px);
            display: flex;
            align-items: center;
            color: #999;
            &.is_self {
              color: #FF9300;
            }
            > img {
              width: pxtorem(18px);
              height: pxtorem(17px);
              margin-right: pxtorem(3px);
            }
          }
        }
        .text_con {
          .p_13 {
            font-size: pxtorem(13px);
            line-height: pxtorem(18px);
            overflow:hidden;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-line-clamp:3;
            -webkit-box-orient:vertical;
          }
        }
        .img_box {
          margin-top: pxtorem(12px);
          img {
            width: pxtorem(56px);
            height: pxtorem(56px);
            border-radius: pxtorem(2px);
            object-fit:cover;
            &:not(:last-child) {
              margin-right: pxtorem(8px);
            }
          }
        }
        .reply {
          background: #F2F5FA;
          font-size: pxtorem(13px);
          color: #262626;
          line-height: pxtorem(18px);
          padding: pxtorem(10px) pxtorem(16px) pxtorem(20px) pxtorem(10px);
          margin-top: pxtorem(20px);
          span {
            &:first-child {
              color: #3189FF;
            }
            &:nth-child(2) {
              overflow:hidden;
              text-overflow:ellipsis;
              display:-webkit-box;
              -webkit-line-clamp:3;
              -webkit-box-orient:vertical;
            }
          }
        }
      }
    }
    .fixed_btn_box {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      position: fixed;
      bottom: pxtorem(70px);
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
    }
    .fixed_btn {
      background:linear-gradient(140deg,rgba(54,173,255,1) 0%,rgba(49,137,255,1) 100%);
      box-shadow:0px 0px 6px 0px rgba(49,137,255,1);
      width: pxtorem(125px);
      height: pxtorem(34px);
      border-radius: pxtorem(19px);
      font-size: pxtorem(14px);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .noData {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-top: pxtorem(150px);
      background: #fff;
      height: 100%;
      box-sizing: border-box;
      img {
        width: pxtorem(305px);
        height: pxtorem(161px);
      }
      p {
        color: #262626;
        font-size: pxtorem(18px);
        text-align: center;
        margin-top: pxtorem(26px);
        font-weight:500;
      }
    }
  }
</style>
<style lang="scss">
  .vue-slim-better-scroll__pullup {
    padding-bottom: 25px;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Consult.vue